import React, { useState } from "react";
import ProductListingStore from "./Components/ProductListingStore";
import ProductListingProduct from "./Components/ProductListingProduct";
import ProductListingCategory from "./Components/ProductListingCategory";
import ProductListingAttributes from "./Components/ProductListingAttributes";
import ProductListingImages from "./Components/ProductListingImages";
import ProductListingVariations from "./Components/ProductListingVariations";
import ProductListingPricing from "./Components/ProductListingPricing";
import ProductListingInventory from "./Components/ProductListingInventory";
import ProductListingReview from "./Components/ProductListingReview";
import ProductListingPublish from "./Components/ProductListingPublish";

const stepsConfig = [
  { key: "store", label: "Store" },
  { key: "product", label: "Product" },
  { key: "category", label: "Category" },
  { key: "attributes", label: "Attributes" },
  { key: "images", label: "Images" },
  { key: "variations", label: "Variations" },
  { key: "pricing", label: "Pricing" },
  { key: "inventory", label: "Inventory" },
  { key: "review", label: "Review" },
  { key: "publish", label: "Publish" }
];

function ProductListingHeader({ activeTab, setActiveTab, handleNext, handleBack }) {
  const activeIndex = stepsConfig.findIndex((s) => s.key === activeTab);

  return (
    <div className="amazon-listing-header-container">
      <h5 className="amazon-listing-sidebar-title ml-4 mt-3">
        Create Amazon Listing
        </h5>
      <div className="amazon-progress-bar ml-4 mt-2">
        {stepsConfig.map((step, index) => {
          let status = index < activeIndex ? "completed" : index === activeIndex ? "active" : "inactive";

          return (
            <div
              key={step.key}
              className={`progress-step ${status}`}
              style={{ zIndex: stepsConfig.length - index, cursor: "pointer" }}
              onClick={() => setActiveTab(step.key)} 
            >
              <span className="step-icon">
                {index < activeIndex ? "✓" : index + 1}
              </span>
              <span className="step-label">{step.label}</span>
            </div>
          );
        })}
      </div>

      <div className="amazon-listing-content mt-4 ml-5 mr-5">
        {activeTab === "store" && <ProductListingStore nextStep={handleNext} prevStep={handleBack} />}
        {activeTab === "product" && <ProductListingProduct nextStep={handleNext} prevStep={handleBack} />}
        {activeTab === "category" && <ProductListingCategory nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "attributes" && <ProductListingAttributes nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "images" && <ProductListingImages nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "variations" && <ProductListingVariations nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "pricing" && <ProductListingPricing nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "inventory" && <ProductListingInventory nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "review" && <ProductListingReview nextStep={handleNext} prevStep={handleBack}/>}
        {activeTab === "publish" && <ProductListingPublish nextStep={handleNext} prevStep={handleBack}/>}
      </div>
    </div>
  );
}

export default ProductListingHeader;